<template>
  <header>
    <div class="container">
      <h6 class="mobNav" @click="mobNav">
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-list" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"/>
        </svg>
      </h6>
      <slot></slot>
    </div>
  </header>
</template>

<script>

export default {
  props: ['mobnav'],
  data () {
    return {

    }
  },
  methods: {
    mobNav() {
      this.$emit('mobnav')
    }
  }
}

</script>

<style>
header {
    height:10vh;
    /*background: #263238;*/
    background: linear-gradient(90deg, #0D0E2C, #511B75, #FF497A);
    display: flex;
    align-items: center;
}
header > div {
    display: flex;
    justify-content: space-between;
}
header > div > h6 {
    display: none;
}
@media (max-width: 767px) {
    header {
        height: 10vh;
        position: fixed;
        width: 100%;
        z-index: 10;
    }
    header > div > h6 {
        display: block;
        color: rgb(255, 193, 7);
        cursor: pointer;
        font-size: 1.5rem;
        text-align: right;
        width: 100%;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue